import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import './Login.css'
import ErrorAwareTextField from '../common/inputfields/ErrorAwareTextField';
import { Button } from '@material-ui/core';
import { withSnackbar } from 'notistack';

class Login extends Component {
    state = {
        userName: '',
        password: '',
        redirectToReferrer: false
    };

    componentDidMount() {
        console.log(process.env.NODE_ENV);
        console.log(process.env.REACT_APP_API_URL);
    }

    handleSubmit = async (event) => {
        const axios = require('axios').default;
        event.preventDefault();
        axios.post('api/login', {
            username: this.state.userName,
            password: this.state.password
        }).then(resp => {
            console.log(resp);
            this.setState(() => ({
                redirectToReferrer: false
            }))
            this.props.setLoggedIn(resp.data);
        })
            .catch(error => {
                console.log(error.response);
                this.props.enqueueSnackbar("Hibás felhasználó vagy jelszó", { variant: 'error', persist: true });
            })

        // console.log(resp);
        // this.setState(() => ({
        //     redirectToReferrer: false
        // }))
        // this.props.setLoggedIn(resp.data);
        // this.props.history.push('/');
    };

    render() {
        const { from } = { from: { pathname: '/' } }
        const { redirectToReferrer } = this.state
        // console.log(from);
        if (redirectToReferrer === true) {
            console.log("object");
            return <Redirect to={from} />
        }
        return (
            <div className="Login">
                <form onSubmit={this.handleSubmit}>
                    <ErrorAwareTextField
                        required
                        name="userName"
                        id="user-name"
                        label="Felhasználónév"
                        value={this.state.userName}
                        onChange={event => this.setState({ userName: event.target.value })}
                    />
                    <br />
                    <br />
                    <ErrorAwareTextField
                        required
                        name="password"
                        id="password"
                        label="Jelszó"
                        type="password"
                        value={this.state.password}
                        onChange={event => this.setState({ password: event.target.value })}
                    />
                    <br />
                    <br />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Bejelentkezés
                    </Button>
                </form>
            </div>
        )
    }
}
export default withSnackbar(Login);